/*
 * @Author: your name
 * @Date: 2021-05-04 09:52:44
 * @LastEditTime: 2024-11-19 16:16:08
 * @LastEditors: Gyan
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\salaryManagement.js
 */
export default [
  {
    name: 'salaryPlan',
    path: '/salaryManagement/salaryPlan',
    component: () =>
      import('@/views/salaryManagement/salaryPlan/salaryPlan.vue'),
    meta: {
      title: '薪酬方案'
    }
  },
  {
    name: 'xuZhouPersonelList',
    path: '/xuZhouPersonel/list',
    component: () => import('@/views/salaryManagement/xuZhouPersonel/List.vue'),
    meta: {
      title: '徐州人员表'
    }
  },
  {
    name: 'salaryBook',
    path: '/salaryBook',
    component: () => import('@/views/salaryManagement/salaryBook'),
    meta: {
      title: '工资记账'
    }
  },
  {
    name: 'dutyFund',
    path: '/salaryManagement/dutyFund',
    component: () => import('@/views/salaryManagement/dutyFund'),
    meta: {
      title: '责任基金'
    }
  },
  {
    name: 'maternityAllowance',
    path: '/maternityAllowance/index',
    component: () =>
      import('@/views/salaryManagement/maternityAllowance/root'),
    meta: {
      title: '生育津贴'
    }
  },
  {
    name: 'laborDisputeList',
    path: '/labor-dispute/list',
    component: () => import('@/views/salaryManagement/labor-dispute/list.vue'),
    meta: {
      title: '劳资纠纷'
    }
  },
  {
    name: 'SalaryBudgetList',
    path: '/salaryBudget/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/salaryBudget/list.vue'),
    meta: {
      title: '薪酬预算'
    }
  },
  {
    name: 'SalaryManagementReportList',
    path: '/salaryManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/salaryManagementReport/index.vue'),
    meta: {
      title: '薪酬管报'
    }
  },
  {
    name: 'dsDeptManagementReportList',
    path: '/dsDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/dsDeptManagementReport/index.vue'),
    meta: {
      title: '电商事业部管报'
    }
  },
  {
    name: 'jjDeptManagementReportList',
    path: '/jjDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/jjDeptManagementReport/index.vue'),
    meta: {
      title: '家居事业部管报'
    }
  },
  {
    name: 'djjxlsDeptManagementReportList',
    path: '/djjxlsDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/djjxlsDeptManagementReport/index.vue'),
    meta: {
      title: '大家居新零售管报'
    }
  },
  {
    name: 'xmtDeptManagementReportList',
    path: '/xmtDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/xmtDeptManagementReport/index.vue'),
    meta: {
      title: '新媒体事业部管报'
    }
  },
  {
    name: 'kzDeptManagementReportList',
    path: '/kzDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/kzDeptManagementReport/index.vue'),
    meta: {
      title: '客中管报'
    }
  },
  {
    name: 'cpDeptManagementReportList',
    path: '/cpDeptManagementReport/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/cpDeptManagementReport/index.vue'),
    meta: {
      title: '产品中心管报'
    }
  },
  {
    name: 'WorkDetailsTableList',
    path: '/workDetailsTable/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/workDetailsTable/list.vue'),
    meta: {
      title: '工资明细表'
    }
  },
  {
    name: 'BusinessDataForecastList',
    path: '/businessDataForecast/list',
    component: () =>
      import(
        '@/views/salaryManagement/manpowerCost/businessDataForecast/index.vue'
      ),
    meta: {
      title: '业务数据预测'
    }
  },
  {
    name: 'OutsourcedWagesTableList',
    path: '/outsourcedWagesTable/list',
    component: () =>
      import(
        '@/views/salaryManagement/manpowerCost/outsourcedWagesTable/index.vue'
      ),
    meta: {
      title: '外包工资台账'
    }
  },
  {
    name: 'yearEndBonusList',
    path: '/yearEndBonus/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/yearEndBonus/list.vue'),
    meta: {
      title: '年终奖明细表'
    }
  },
  {
    name: 'accrueSumList',
    path: '/accrueSum/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/accrueSum/list.vue'),
    meta: {
      title: '计提汇总核算'
    }
  },
  {
    name: 'yearEndBonusManagementList',
    path: '/yearEndBonusManagement/list',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/yearEndBonusManagement/list.vue'),
    meta: {
      title: '年终奖管理'
    }
  },
  {
    name: 'yearEndBonusManagementDetail',
    path: '/yearEndBonusManagement/detail',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/yearEndBonusManagement/detail.vue'),
    meta: {
      title: '年终奖管理明细',
      parentAuth: '/yearEndBonusManagement/list'
    }
  },
  {
    name: 'salaryPlanSummaryList',
    path: '/finSumTables/salaryPlanSummary',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/finSumTables/salaryPlanSummary/index.vue'),
    meta: {
      title: '工资汇总表（计提）'
    }
  },
  {
    name: 'yearEndBonusActualList',
    path: '/finSumTables/yearEndBonusActualList',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/finSumTables/yearEndBonusActualList/index.vue'),
    meta: {
      title: '年终奖实发计提'
    }
  },
  {
    name: 'actualSalarySummary',
    path: '/monthlySalarySummary/actualSalarySummary',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/monthlySalarySummary/actualSalarySummary/index.vue'),
    meta: {
      title: '实发计提汇总'
    }
  },
  {
    name: 'deductionSummary',
    path: '/feeSumTables/deductionSummary',
    component: () =>
      import('@/views/salaryManagement/manpowerCost/feeSumTables/deductionSummary/index.vue'),
    meta: {
      title: '扣款汇总表'
    }
  },
  {
    name: 'baseSalaryManagement',
    path: '/baseSalaryManagement/list',
    component: () =>
      import('@/views/salaryManagement/baseSalaryManagement/list.vue'),
    meta: {
      title: '定薪管理'
    }
  },
  {
    name: 'changeSalaryManagement',
    path: '/changeSalaryManagement/list',
    component: () =>
      import('@/views/salaryManagement/changeSalaryManagement/list.vue'),
    meta: {
      title: '调薪管理'
    }
  },
  {
    name: 'additionAndSubtraction',
    path: '/additionAndSubtraction/list',
    component: () =>
      import(
        '@/views/salaryManagement/dataManagement/additionAndSubtraction/index.vue'
      ),
    meta: {
      title: '加项-减项数据维护'
    }
  },
  {
    name: 'bonusDataManagement',
    path: '/bonusDataManagement/index',
    component: () =>
      import('@/views/salaryManagement/dataManagement/bonusData/root'),
    meta: {
      title: '奖金数据维护'
    }
  },
  {
    name: 'residentAccommodation',
    path: '/residentAccommodation/list',
    component: () =>
      import(
        '@/views/salaryManagement/dataManagement/residentAccommodation/inedex'
      ),
    meta: {
      title: '品质驻厂住宿导入'
    }
  },
  {
    name: 'salaryActivityConfig',
    path: '/salaryManagement/salaryActivityConfig',
    component: () =>
      import('@/views/salaryManagement/salaryActivityConfig/index'),
    meta: {
      title: '发薪活动配置'
    }
  },
  {
    name: 'salaryActivity',
    path: '/salaryManagement/salaryActivity',
    component: () => import('@/views/salaryManagement/salaryActivity/index'),
    meta: {
      title: '发薪活动'
    }
  },
  {
    name: 'salaryAccounting',
    path: '/salaryManagement/salaryAccounting',
    component: () =>
      import('@/views/salaryManagement/salaryActivity/salaryAccounting/index'),
    meta: {
      title: '工资核算',
      parentAuth: '/salaryManagement/salaryActivity'
    }
  },
  {
    name: 'accountingFormulaConfiguration',
    path: '/salaryManagement/accountingFormulaConfiguration',
    component: () =>
      import(
        '@/views/salaryManagement/accountingFormulaConfiguration/index'
      ),
    meta: {
      title: '核算公式配置',
    }
  },
  {
    name: 'salaryApplicationList',
    path: '/salaryManagement/salaryApplicationList',
    component: () =>
      import(
        '@/views/salaryManagement/salaryApplicationList/index'
      ),
    meta: {
      title: '薪酬请示单',
    }
  },
  {
    name: 'salarySchemeConfig',
    path: '/salaryManagement/salarySchemeConfig',
    component: () =>
      import(
        '@/views/salaryManagement/salarySchemeConfig/index'
      ),
    meta: {
      title: '薪酬方案',
    }
  },
  {
    name: 'personalIncomeTaxManagement',
    path: '/salaryManagement/personalIncomeTaxManagement',
    component: () =>
      import(
        '@/views/salaryManagement/personalIncomeTaxManagement/index'
      ),
    meta: {
      title: '个税管理',
    }
  },
  {
    name: "salaryRange",
    path: "/salaryManagement/salaryRange",
    component: () => import("@/views/salaryManagement/salaryRange/index.vue"),
    meta: {
      title: "薪酬区间表",
    },
  },
  {
    name: 'personalIncomeTaxPlan',
    path: '/salaryManagement/personalIncomeTaxPlan',
    component: () =>
      import(
        '@/views/salaryManagement/personalIncomeTaxPlan/index'
      ),
    meta: {
      title: '个税筹划',
    }
  },
  {
    name: 'personalIncomeTaxPlanPersonList',
    path: '/salaryManagement/personalIncomeTaxPlanPersonList',
    component: () =>
      import(
        '@/views/salaryManagement/personalIncomeTaxPlanPersonList/index'
      ),
    meta: {
      title: '个税筹划人员名单',
      parentAuth: '/salaryManagement/personalIncomeTaxPlan'
    }
  },
];
